"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSQSIPv6QueueURL = exports.getSQSQueueARN = exports.getSQSQueueURL = exports.mapToMOCKEventTriggerSQSMessageAttributes = exports.sQSMessageAttributesToMap = exports.sQSNativeMessageAttributesToMap = exports.mapToSQSMessageAttributes = exports.isSQSUnStringedMessageNamedQueueRequest = exports.isSQSUnStringedMessageRequest = exports.isSQSUnStringedMessageBase = void 0;
const { AWS_DEFAULT_REGION, accountId, } = process.env;
const debug = false;
const isSQSUnStringedMessageBase = (x) => {
    const c = x;
    return !!c && typeof c.MessageAttributes === 'object' && typeof c.MessageBody === 'object';
};
exports.isSQSUnStringedMessageBase = isSQSUnStringedMessageBase;
const isSQSUnStringedMessageRequest = (x) => {
    const c = x;
    return !!c && (0, exports.isSQSUnStringedMessageBase)(c) && typeof c.QueueUrl === 'string';
};
exports.isSQSUnStringedMessageRequest = isSQSUnStringedMessageRequest;
const isSQSUnStringedMessageNamedQueueRequest = (x) => {
    const c = x;
    return !!c && (0, exports.isSQSUnStringedMessageBase)(c) && typeof c.QueueName === 'string';
};
exports.isSQSUnStringedMessageNamedQueueRequest = isSQSUnStringedMessageNamedQueueRequest;
const mapToSQSMessageAttributes = (ob) => {
    const messageAttributes = {};
    Object.entries(ob).forEach(([k, v]) => {
        if (typeof v === 'string') {
            messageAttributes[k] = {
                DataType: 'String',
                StringValue: v,
            };
        }
        else if (typeof v === 'number') {
            messageAttributes[k] = {
                DataType: 'Number',
                StringValue: v.toString(),
            };
        }
        else if (typeof v === 'boolean') {
            messageAttributes[k] = {
                DataType: 'Boolean',
                StringValue: v.toString(),
            };
        }
        else {
            debug && console.log(`${k} with value ${v} not supported yet, only doing strings, booleans, numbers`);
        }
    });
    return messageAttributes;
};
exports.mapToSQSMessageAttributes = mapToSQSMessageAttributes;
// NATIVE SQS version
const sQSNativeMessageAttributesToMap = (ob) => {
    const map = {};
    if (ob) {
        Object.entries(ob).forEach(([k, v]) => {
            if (v.StringValue) {
                if (v.DataType === 'String') {
                    map[k] = v.StringValue;
                }
                else if (v.DataType === 'Number') {
                    map[k] = parseFloat(v.StringValue);
                }
                else if (v.DataType === 'Binary') {
                    map[k] = v.StringValue === 'true';
                }
                else if (v.DataType) {
                    debug && console.log(`${k} with type ${typeof v} value ${v} not supported yet, only doing strings, booleans, numbers`);
                }
                else {
                    debug && console.log(`${k} with type ${typeof v} value ${v} could not be processed`);
                }
            }
        });
    }
    return map;
};
exports.sQSNativeMessageAttributesToMap = sQSNativeMessageAttributesToMap;
// LAMBDA Event version
const sQSMessageAttributesToMap = (ob) => {
    const map = {};
    Object.entries(ob).forEach(([k, v]) => {
        if (v.stringValue) {
            if (v.dataType === 'String') {
                map[k] = v.stringValue;
            }
            else if (v.dataType === 'Number') {
                map[k] = parseFloat(v.stringValue);
            }
            else if (v.dataType === 'Boolean') {
                map[k] = v.stringValue === 'true';
            }
            else if (v.dataType) {
                debug && console.log(`${k} with type ${typeof v} value ${v} not supported yet, only doing strings, booleans, numbers`);
            }
            else {
                debug && console.log(`${k} with type ${typeof v} value ${v} could not be processed`);
            }
        }
    });
    return map;
};
exports.sQSMessageAttributesToMap = sQSMessageAttributesToMap;
const mapToMOCKEventTriggerSQSMessageAttributes = (ob) => {
    const messageAttributes = {};
    Object.entries(ob).forEach(([k, v]) => {
        if (typeof v === 'string') {
            messageAttributes[k] = {
                dataType: 'String',
                stringValue: v,
            };
        }
        else if (typeof v === 'number') {
            messageAttributes[k] = {
                dataType: 'Number',
                stringValue: v.toString(),
            };
        }
        else if (typeof v === 'boolean') {
            messageAttributes[k] = {
                dataType: 'Boolean',
                stringValue: v.toString(),
            };
        }
        else {
            debug && console.log(`${k} with value ${v} not supported yet, only doing strings, booleans, numbers`);
        }
    });
    return messageAttributes;
};
exports.mapToMOCKEventTriggerSQSMessageAttributes = mapToMOCKEventTriggerSQSMessageAttributes;
/** returns the SQS Queue URL using the original SQS enpoint which as of 2025 11 does not appear to be dualstack */
const getSQSQueueURL = (queueName) => `https://sqs.${AWS_DEFAULT_REGION}.amazonaws.com/${accountId}/${queueName}`;
exports.getSQSQueueURL = getSQSQueueURL;
const getSQSQueueARN = (queueName) => `arn:aws:sqs:${AWS_DEFAULT_REGION}:${accountId}:${queueName}`;
exports.getSQSQueueARN = getSQSQueueARN;
/** returns the SQS Queue URL using the dual stack SQS enpoint */
const getSQSIPv6QueueURL = (queueName) => `https://sqs.${AWS_DEFAULT_REGION}.api.aws/${accountId}/${queueName}`;
exports.getSQSIPv6QueueURL = getSQSIPv6QueueURL;
/** resolves SQS Queue url, returing the IPv6 version if the process is running in VPC */
// TODO - need to think through whether clients in processes running on ECS in public subnet but not explictly set to use DualStack can resolve IPv6
// this will need proper verification
